export default "__VITE_ASSET__DxFMmoEr__"